/** Query params for dashboard analytics endpoints (use axios `params`, not URL string). */
export function buildDashboardApiParams({
  dateFrom,
  dateTo,
  brandId,
  branchId,
  categoryId,
  platform,
} = {}) {
  const params = {};
  if (dateFrom) params.dateFrom = dateFrom;
  if (dateTo) params.dateTo = dateTo;
  if (brandId) params.brandId = brandId;
  if (branchId) params.branchId = branchId;
  if (categoryId) params.categoryId = categoryId;
  if (platform) params.platform = platform;
  return params;
}
